<template>
    <div>
        <iframe src="https://api.ldpa.us/" class="frame"></iframe>
        <!--<iframe src="https://cloud.ldpa.us/index.php/login" class="frame"></iframe>-->
        <!--<iframe src="https://telecom.ldpa.com" class="frame"></iframe>-->
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
	data() {
		return {

		}
	},
    async created () {

    },
	methods: {

	}
}
</script>

<style scoped>
.frame{
    width:100%;
    height:calc(100vh - 60px);
    border:none;
}
</style>



// WEBPACK FOOTER //
// src/components/file/OwnCloud.vue